export const MEDIA_TYPES = {
  IMAGES: 'images',
  VIDEOS: 'videos',
};

export const POPULAR_CATEGORIES = [
  { name: 'Architecture', media_type: MEDIA_TYPES.IMAGES, phrase: 'architecture' },
  { name: 'Fitness and wellness', media_type: MEDIA_TYPES.IMAGES, phrase: 'fitness and wellness' },
  { name: 'Jobs and careers', media_type: MEDIA_TYPES.IMAGES, phrase: 'jobs and careers' },
  { name: 'Seasonal and holiday', media_type: MEDIA_TYPES.IMAGES, phrase: 'seasonal and holiday' },
  { name: 'Business and finance', media_type: MEDIA_TYPES.IMAGES, phrase: 'business and finance' },
  { name: 'Food and drink', media_type: MEDIA_TYPES.IMAGES, phrase: 'food and drink' },
  { name: 'Moods and feelings', media_type: MEDIA_TYPES.IMAGES, phrase: 'moods and feelings' },
  { name: 'Special occasions', media_type: MEDIA_TYPES.IMAGES, phrase: 'special occasions' },
  { name: 'Education', media_type: MEDIA_TYPES.IMAGES, phrase: 'education' },
  { name: 'Happiness', media_type: MEDIA_TYPES.IMAGES, phrase: 'happiness' },
  { name: 'Nature and landscapes', media_type: MEDIA_TYPES.IMAGES, phrase: 'nature and landscapes' },
  { name: 'Sports and recreation', media_type: MEDIA_TYPES.IMAGES, phrase: 'sports and recreation' },
  { name: 'Family', media_type: MEDIA_TYPES.IMAGES, phrase: 'family' },
  { name: 'Healthcare and medicine', media_type: MEDIA_TYPES.IMAGES, phrase: 'healthcare and medicine' },
  { name: 'Pets and animals', media_type: MEDIA_TYPES.IMAGES, phrase: 'pets and animals' },
  { name: 'Travel destinations', media_type: MEDIA_TYPES.IMAGES, phrase: 'travel destinations' },
  { name: 'Fashion and beauty', media_type: MEDIA_TYPES.IMAGES, phrase: 'fashion and beauty' },
  { name: 'Science and technology', media_type: MEDIA_TYPES.IMAGES, phrase: 'science and technology' },
].sort((a, b) => (a.name > b.name ? 1 : -1));

export const DIVERSITY_CATEGORIES = [
  { name: 'Authenticity', media_type: MEDIA_TYPES.IMAGES, phrase: 'authenticity' },
  { name: 'Community activism', media_type: MEDIA_TYPES.IMAGES, phrase: 'community activism' },
  { name: 'Female leaders', media_type: MEDIA_TYPES.IMAGES, phrase: 'female leaders' },
  { name: 'Mental health', media_type: MEDIA_TYPES.IMAGES, phrase: 'mental health' },
  { name: 'Body positivity', media_type: MEDIA_TYPES.IMAGES, phrase: 'body positivity' },
  { name: 'Disability in sports', media_type: MEDIA_TYPES.IMAGES, phrase: 'disability in sports' },
  { name: 'Humanizing tech', media_type: MEDIA_TYPES.IMAGES, phrase: 'humanizing tech' },
  { name: 'Sustainability', media_type: MEDIA_TYPES.IMAGES, phrase: 'sustainability' },
].sort((a, b) => (a.name > b.name ? 1 : -1));

export const MAIN_PAGE_CATEGORY_PHRASE = 'adventure';
export const MAIN_PAGE_SEARCH_PARAMS = {
  searchPhrase: MAIN_PAGE_CATEGORY_PHRASE,
  mediaType: MEDIA_TYPES.IMAGES,
  pageSize: 4,
  filters: {
    excludeNudity: true,
  },
};
export const MAIN_PAGE_CATEGORY_LABEL = 'Adventure';

export const DEFAULT_PAGE_SIZE = 30;

export const ROUTES = {
  HOME: '',
  SEARCH: 'search',
  PURCHASE: 'purchase',
};

export const FILTERS_BY_MEDIA_TYPE = {
  [MEDIA_TYPES.IMAGES]: [
    'sortBy',
    'license',
    'licenseType',
    'orientations',
    'minimumSize',
    'numberOfPeople',
    'compositions',
    'color',
    'imagesMore',
    'excludeEditorialUseOnly',
    'embedContentOnly',
    'excludeNudity',
  ],
  [MEDIA_TYPES.VIDEOS]: [
    'sortBy',
    'license',
    'licenseType',
    'formatAvailable',
    'licenseModels',
    'duration',
    'frameRates',
    'videoCompositions',
    'viewpoints',
    'imageTechniques',
    'more',
    'excludeNudity',
  ],
};

export const INVALID_TOKEN_CODE = 401;

export const CREDIT_PRICES = {
  [MEDIA_TYPES.IMAGES]: {
    essentials: 1,
    signature: 3,
  },
  [MEDIA_TYPES.VIDEOS]: {
    essentials: 6,
    signature: 18,
  },
};
export const MINIMUM_SIZE_OPTIONS = ['large', 'x_large', 'xx_large'];
// there are some differences between API documentation and getty webpage on options below.
// more details you can find https://api.gettyimages.com/swagger/index.html
export const IMAGE_STYLE_OPTIONS = ['abstract', 'portrait', 'close_up', 'sparse', 'cut_out', 'full_frame', 'copy_space', 'macro', 'still_life'];

export const FRAME_RATE_OPTIONS = ['23.98', '24', '25', '29.97', '30', '50', '59.94', '60'];

export const IMAGE_TECHNIQUES_OPTIONS = ['realtime', 'time_lapse', 'slow_motion', 'color', 'black_and_white', 'animation', 'selective_focus'];

export const VIEW_POINT_OPTIONS = ['lockdown', 'panning', 'tracking_shot', 'aerial_view', 'high_angle_view', 'low_angle_view', 'tilt', 'point_of_view'];

export const COMPOSITIONS_OPTIONS = ['close_up', 'candid', 'looking_at_camera'];

export const LICENSE_MODEL_OPTIONS = ['royaltyfree', 'rightsready', 'all'];

export const authorLink = (assetFamily, artist) => `https://www.gettyimages.com/search/photographer?family=${assetFamily}&photographer=${artist}`;

export const LICENSE_TYPE_LINK = 'https://www.gettyimages.com/eula';
